
/**
 * @fileOverview NavigationSubMenuController Module File
 * this file is used to control the hiding and showing of the sub-navigation when it is in the accordion view only
 *
 * @author jmaki
 * @version 1.0
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/NavigationSubMenuController',['require','lib/Util','jquery','GlobalEventDispatcher'],function (require) {
        var Util = require('lib/Util');
        var $ = require('jquery');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');

        /**
         * Description
         *
         * @name NavigationSubMenuController
         * @class NavigationSubMenuController controls the sub-navigation behavior when elements are int he accordion view
         * @constructor
         *
         * @since 1.0
         */
        $debug('NavigationSubMenuController loaded - use ?debug=navSubMenuController for messages');
        var NavigationSubMenuController = function (element) {
            this.$trigger = $(element); //wraps the trigger element in a jQuery object
            this.$target = undefined;
            this.targetActiveClass = 'MMM--navItemList-hasSubNav_isOpen';
            this.settings = undefined; //used to store the settings

            $debug('     Trigger Element: ' + $.trim(this.$trigger.text()),'navSubMenuController');

            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @returns {NavigationSubMenuController}
         * @since 1.0
         */
        NavigationSubMenuController.prototype.init = function () {
            this.isEnabled = false;
            if (this.$trigger.length > 0) {
                return this.setOptions()
                    .setupHandlers()
                    .createChildren()
                    .enable();
            }

            return this;
        };
        /**
         * Merges options from the DOM element with defaults
         * @return {NavigationSubMenuController}
         * @since 1.0
         */
        NavigationSubMenuController.prototype.setOptions = function () {
            var options = this.$trigger.data().options;

            var defaults = {
                resetEvent: undefined, //the event that the menu will reset on
                enableOn: ['smallContext', 'mediumContext'],
                disableOn: ['largeContext', 'luxuryContext'],
                closeOn: ['menuClose', 'smallContext', 'mediumContext', 'largeContext', 'luxuryContext']
            };

            this.settings = $.extend({}, defaults, options);

            //output debug items
            $debug('     SubMenuConroller Options ', 'navSubMenuController');
            $debug('          HTML data-options Settings: ' + $printObj(options),'navSubMenuController');
            $debug('          Default Settings: ' + $printObj(defaults),'navSubMenuController');
            $debug('          Combined Settings: ' + $printObj(this.settings),'navSubMenuController');
            $debug('','navSubMenuController');
            $debug('','navSubMenuController');
            //end debug block

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @returns {NavigationSubMenuController}
         * @since 1.0
         */
        NavigationSubMenuController.prototype.createChildren = function () {
            this.$target = this.$trigger.next('.js-subNavDrawer');

            return this;
        };

        /**
         * Set up handlers and callbacks
         *
         * @returns {NavigationSubMenuController}
         * @since 1.0
         */
        NavigationSubMenuController.prototype.setupHandlers = function () {
            var self = this,
                i,
                obj;

            this.$trigger.on('click', function (event) {
                $debug($.trim(self.$trigger.text()) + ' Element Clicked!','navSubMenuController');
                //needed for IE Support
                if (event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }
                $debug('    Enabled? ' + self.isEnabled,'navSubMenuController');
                if (self.isEnabled !== false) {
                    $debug('   Opening ' + $.trim(self.$target.text()),'navSubMenuController');
                    self.$target.slideToggle();
                    self.$trigger.parent('li').toggleClass(self.targetActiveClass);
                }
            });

            // subscribe to the events that should cause the the function to enable
            for (i = 0; i < this.settings.enableOn.length; i++) {
                obj = this.settings.enableOn[i];
                self.eventDispatcher.subscribe(obj, this.enable.bind(self));
            }

            // subscribe to the events that should cause the the function to disable
            for (i = 0; i < this.settings.disableOn.length; i++) {
                obj = this.settings.disableOn[i];
                self.eventDispatcher.subscribe(obj, this.disable.bind(self));
            }

            //subscribe to the events that should trigger the close event
            for (i = 0; i < this.settings.closeOn.length; i++) {
                obj = this.settings.closeOn[i];
                self.eventDispatcher.subscribe(obj, this.close.bind(self));
            }
            return this;
        };

        /**
         * Enables the module
         * Exits early if it is already enabled
         *
         * @returns {NavigationSubMenuController}
         * @since 1.0
         */
        NavigationSubMenuController.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;

            return this;
        };

        /**
         * Disables the view
         * Exits early if it is already disabled
         *
         * @returns {NavigationSubMenuController}
         * @since 1.0
         */
        NavigationSubMenuController.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.$target.attr('style', '');

            this.isEnabled = false;

            return this;
        };

        /**
         * closes
         * @return {NavigationSubMenuController}
         */
        NavigationSubMenuController.prototype.close = function () {
            var self = this;
            this.$trigger.parent('li').removeClass(self.targetActiveClass);

            return this;
        };

        return NavigationSubMenuController;
    });

}(MMMRequire));


